import React, { useEffect, useState } from "react";

// Extracted from CopySection for RPAA-181: with N page contexts there is one
// patterns field per context, so the raw text buffer below has to be per
// instance rather than a single useState in the parent.
const PatternListField = ({ value, onChange, label, hint, placeholder }) => {
  const saved = value || [];

  // The textarea keeps its own raw text. Deriving `value` from the saved array
  // instead would make a line-in-progress unrepresentable: an empty new line is
  // dropped by filter(Boolean), so React restores the joined string and
  // pressing Enter does nothing — consecutive patterns silently merge into one.
  // The buffer is the DOM's source of truth; the array is derived from it.
  const [raw, setRaw] = useState(() => saved.join("\n"));

  // Re-seed only when the saved value stops matching what this buffer parses
  // to: covers the card's Discard and a save or reload that changed the
  // patterns, but never the user's own keystrokes, which already agree. Keying
  // this on a `baseline` prop instead would miss Discard, which drops the
  // card's draft without touching what is saved.
  useEffect(() => {
    const parsed = raw
      .split("\n")
      .map((l) => l.trim())
      .filter(Boolean);
    if (JSON.stringify(parsed) !== JSON.stringify(saved)) {
      setRaw(saved.join("\n"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <div>
      <label className="block text-xs font-medium uppercase tracking-wide mb-2"
        style={{ color: "var(--color-text-primary)" }}>
        {label}
      </label>
      <textarea
        value={raw}
        onChange={(e) => {
          setRaw(e.target.value);
          const lines = e.target.value
            .split("\n")
            .map((l) => l.trim())
            .filter(Boolean);
          // null (not []) so the caller's set() deletes the key — the widget
          // treats an absent list as "no patterns".
          onChange(lines.length ? lines : null);
        }}
        rows={3}
        className="field-input resize-y w-full font-mono text-sm"
        placeholder={placeholder}
      />
      {hint ? (
        <p className="mt-1 text-xs" style={{ color: "var(--color-text-muted)" }}>
          {hint}
        </p>
      ) : null}
    </div>
  );
};

export default PatternListField;
